import * as React from 'react';

import locationServiceInstance from 'src/services/location/LocationService';
import { IExtraProduct } from 'src/model/productdetails.model';
import env from 'src/shared/env';

import './PickUpTab.scss';
import PickUpRow from '../PickUpRow';

export interface IPart {
  images: string[];
  modelsFound: number;
  name: string;
  productNumber: string;
  description: string;
  price: number;
  msrp: number;
  inStock: boolean;
  supplierQuantity: number;
  state: string;
  extraProducts: IExtraProduct[];
  extraTotalAmount: number;
  pickUpFrom: string;
  pickUpTo: string;
  shipFrom: string;
  shipToName: string;
  shipToAddress: string;
  manufacturer?: string;
  manufacturerCode?: string;
  replacedPart: string;
  replacedMfc: string;
  stateDescription: string;
  specialOrder: boolean;
  discountInfo: any;
}

interface IDeliverAddress {
  warehouseCode: string;
  suppliedFrom: string;
  description: string;
  quantity: number;
  name: string;
  default: boolean;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IPickUpDeliverAddressChangeProps {
  defaultWarehouse: any;
  supplierQuantity: number;
  deliverAddresses: IDeliverAddress[];
  selectedShipFrom: object;
  selectedPickup: string;
  handleChangeAddress: (shipFromAddress: {
    [key: string]: { qty: string; available: number };
  }) => void;
  part: IPart;
  handleChangePickUp(): void;
  isAddedToCart: boolean;
  setAddedToCart: (val: boolean) => void;
  isMounted: boolean;
  setMounted: (val: boolean) => void;
  defaultItemsToShow: number;
  handleOnInputChange: (
    warehouse: string,
    qty: string,
    available: number,
    consignment: string,
    setAlert: (params: any) => void
  ) => void;
  setDefaultValues: () => void;
  getWarehouses: () => any;
  shipFromAddress: any;
  setShipFromAddress: (shipFromAddress: any) => void;
  getPickUpAddresses: (value?: boolean) => void;
  cartDeliverMethod: 'shipping' | 'pick-up' | '';
  t?: any;
}

interface IPickUpDeliverAddressChangeState {
  zipCode: string;
  itemsToShow: number;
  expanded: boolean;
}

let MAX_LENGTH_ELEMENTS = 4;

class PickUpTab extends React.Component<
  IPickUpDeliverAddressChangeProps,
  IPickUpDeliverAddressChangeState
> {
  public scrollDiv: any;
  constructor(props: any) {
    super(props);
    this.state = {
      zipCode: '',
      itemsToShow: this.props.defaultItemsToShow,
      expanded: false
    };
    this.scrollDiv = React.createRef();
    MAX_LENGTH_ELEMENTS = this.props.defaultItemsToShow;
  }

  private showMore = () => {
    this.state.itemsToShow === this.props.defaultItemsToShow
      ? this.setState({
          itemsToShow: this.props.deliverAddresses.length,
          expanded: true
        })
      : this.setState({
          itemsToShow: this.props.defaultItemsToShow,
          expanded: false
        });
  };

  private scrollSmoothHandler = () => {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
  };

  public componentDidMount() {
    if (!this.props.isMounted) {
      this.props.setShipFromAddress(this.props.selectedShipFrom);
    } else {
      this.props.setDefaultValues();
      this.props.setMounted(false);
    }
  }

  public componentDidUpdate(prevProps: any) {
    if (
      this.props.isMounted &&
      Object.keys(this.props.selectedShipFrom)[0] !==
        Object.keys(prevProps.selectedShipFrom)[0]
    ) {
      this.props.setMounted(false);
    } else {
      if (
        Object.keys(this.props.selectedShipFrom)[0] !==
        Object.keys(prevProps.selectedShipFrom)[0]
      ) {
        this.props.setShipFromAddress(this.props.selectedShipFrom);
      }
    }

    if (
      this.props.isAddedToCart &&
      this.props.isAddedToCart !== prevProps.isAddedToCart
    ) {
      this.props.setDefaultValues();
      this.props.setAddedToCart(false);
    }
  }

  private renderPickUpRow = (address: IDeliverAddress) => {
    return (
      <PickUpRow
        key={address.warehouseCode}
        address={address}
        shipFromAddress={this.props.shipFromAddress}
        handleOnInputChange={this.props.handleOnInputChange}
        isBold={address.default}
        disabledPickup={
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? this.props.selectedPickup !== address.code && address.pickUpOnly
            : false
        }
        handleChangePickUp={this.props.handleChangePickUp}
        stateQty={this.props.part.state}
      />
    );
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-pick-up-tab--info">
        <div ref={this.scrollDiv} className="rp-pick-up-tab--pick-up-address">
          <p className="rp-pick-up-tab--address-title">
            {t('product.pickup')} {t('product.store')}:
          </p>
          <span className="rp-pick-up-tab--address">
            {this.props.part.pickUpTo !== ''
              ? this.props.part.pickUpTo
              : 'No warehouses available'}
          </span>
          <button
            className="rp-pick-up-tab--address--change"
            onClick={() => this.props.handleChangePickUp()}
          >
            {t('common.change')}
          </button>
        </div>
        <div className="rp-pick-up-tab--directions-text">
          {t('product.suppliedFrom')}:
        </div>
        <div className="rp-pick-up-tab--addresses">
          <div className="rp-pick-up-tab--addresses--titles-desktop">
            <div className="rp-pick-up-tab--addresses--title-store-desktop">
              {t('product.store')}
            </div>
            <div className="rp-pick-up-tab--addresses--title-availability-desktop">
              {t('product.availability')}
            </div>
            <div className="rp-pick-up-tab--addresses--title-qty-desktop">
              {t('myFavourites.qty')}:
            </div>
          </div>
          {this.props.deliverAddresses.length > 0 &&
            this.props
              .getWarehouses()
              .slice(0, this.state.itemsToShow)
              .map((address: any) => (
                <div
                  key={address.warehouseCode}
                  className="rp-pick-up-tab--deliver-wrapper"
                >
                  <div className="rp-divider" />
                  {this.renderPickUpRow(address)}
                </div>
              ))}

          {this.props.deliverAddresses.length > MAX_LENGTH_ELEMENTS && (
            <div
              className="rp-pick-up-tab--addresses--show-more-toggle"
              onClick={this.showMore}
            >
              {this.state.expanded ? (
                <React.Fragment>
                  <div
                    onClick={this.scrollSmoothHandler}
                    className="rp-pick-up-tab--show-more-toggle"
                  >
                    <span className="rpds-remove" />
                    <span className="rp-pick-up-tab--show-more-toggle-text">
                      {t('product.showLessWarehouses')}
                    </span>
                  </div>
                  <div className="rp-deliver-address-change--supplier">
                    {t('product.manufacturerQuantity')}
                    <span className="rp-deliver-address-change--supplier-count">
                      {this.props.supplierQuantity}
                    </span>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="rp-pick-up-tab--show-more-toggle">
                    <span className="rpds-add" />
                    <span className="rp-pick-up-tab--show-more-toggle-text">
                      {t('product.showMoreWarehouses')}
                    </span>
                  </div>
                  <div className="rp-deliver-address-change--supplier">
                    {t('product.manufacturerQuantity')}
                    <span className="rp-deliver-address-change--supplier-count">
                      {this.props.supplierQuantity}
                    </span>
                  </div>
                </React.Fragment>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PickUpTab;
